export const m = {
  EnterID: "Bitte klicken Sie, um die Tada-ID einzugeben",
  "select-specifications":
    "Bitte klicken Sie, um die Aufladespezifikation auszuwählen",
  "check-account": "Bitte überprüfen Sie das Aufladekonto",
  whatID: "Was ist Tada ID?",
  getID: "Bitte geben Sie die Tada ID ein",
  maskgetID: "Bitte geben Sie die Tada ID ein",
  "toastTips-format-error": "Falsches Format",
  "toastTips-no-exist": "Die ID existiert nicht",
  toastTipsPlease: "Bitte überprüfen Sie zuerst Ihr Aufladekonto",
  "common-problem": "häufiges Problem",
  "transaction-succeeded": "Die Transaktion its erfolgreich",
  "transaction-failed": "Die Transaktion ist nicht erfolgreich",
  "transaction-cancel": "Die Transaktion wurde abgebrochen",
  "whether-account":
    "1. Wie kann ich bestätigen, ob das Konto nach dem Aufladen bezahlt wird?",
  "answer-whether-account":
    "Nach dem Aufladen können Sie zu [Meine] - [Brieftasche] der App zurückkehren, um Diamanten anzuzeigen",
  "no-account":
    "2.Was soll ich tun, wenn nach dem Aufladen keine Zahlung erfolgt?",
  "answer-no-account":
    "Bitte senden Sie Ihre Fragen in [Nachricht] - [Offizielle Nachrichten] - [Feedback und Hilfe] der App und geben Sie die folgenden Informationen an. Unser Kundendienst hilft Ihnen dabei. ",
  "recharge-money": "1. Geben Sie den Aufladebetrag und die Konto-ID an",
  "recharge-time": "2. Geben Sie die Uhrzeit und das Datum des Aufladens an",
  "recharge-shot":
    "3. Geben Sie einen Screenshot der erfolgreichen Zahlung an.",
  "recharge-wrong":
    "3.Was soll ich tun, wenn ich das falsche Konto und den falschen Betrag belaste?",
  "answer-recharge-wrong":
    "Da der falsche Betrag nicht erstattet werden kann, müssen Sie vor der Eingabe des Zahlungskennworts die ID des Aufladekontos und die Informationen zum Aufladebetrag sorgfältig bestätigen. Wenn das Konto falsch belastet wird, können Sie versuchen, den tatsächlich aufgeladenen ID-Benutzer zu kontaktieren und mit ihm zu verhandeln, ob er bereit ist, Ihre Aufladung zu kompensieren.",
  refund: "4.Rückerstattung",
  "answer-refund":
    "Es tut uns leid! Tada unterstützt derzeit keine Rückerstattungen.",
  "buy-enter-link":
    'Wenn Sie Diamanten kaufen möchten, können Sie diese über den Link <a class = "web-link" href="<a class= "web-link" href= "https: //pay.tadachat.info/" >https://pay.tadachat.info</a> aufladen. Kopieren Sie den Link und öffnen Sie ihn im mobilen Browser, rufen Sie die Kaufseite auf, überprüfen Sie das Konto, wählen Sie die entsprechenden Spezifikationen aus und zahlen Sie mit der entsprechenden Zahlungsmethode ~ Es gibt viele Rabatte!',
  "buy-notice-a":
    "Hinweis: <a>pay.tadachat.info</a> ist die einzige offizielle Website zum Kauf von Diamanten für Tada",
  replace: "Wechseln",
  sureBtn: "OK",
  "pay-style": "Zahlungsart auswählen",
  goBack: "Zurück zur Homepage",
  toastTips: "Bitte geben Sie die Tada ID ein",
  rechargeFAQ_title: "häufiges Problem",
  PayStatusSuccess_title: "Die Transaktion its erfolgreich",
  PayStatusFail_title: "Die Transaktion ist nicht erfolgreich",
  PayStatusCancel_title: "Die Transaktion wurde abgebrochen",
  Diamonds_title: "Offizielle Website von Tada zum Aufladen von Diamanten",
  "buy-notice":
    "Hinweis pay.Tadachat.info ist die einzige offizielle Diamantkauf-Website von Tada. Für Kundendienstanfragen gehen Sie bitte zu [Nachricht] - [Offizielle Nachrichten] - [Feedback und Hilfe]",
  RechargeHelp_title: "Aufladen Hilfe",
  openAPP: "Öffnen Sie die Tada-App",
  "buy-diamonds-tit": "Kaufen Diamond Services",
  description:
    "Tada ist die einzige offizielle Website zum Aufladen von Diamanten. Tada ist eine internationale soziale Software, die von Benutzern in mehr als 150 Ländern und Regionen auf der ganzen Welt verwendet wird.",
  keywords:
    "Tada-Aufladung,Tada-Diamantaufladung,offizielle Aufladung von Tada,offizielle Website zum Aufladen von Tada",
  trueText: "ok",
  falseText: "Abbrechen",
  alertShowTxt1: "Sind Sie sicher,",
  alertShowTxt3: "zu verwenden, um",
  alertShowTxt5: "Diamanten aufzuladen?",
  payforType: "Auflademethode",
  EnterIDTip: "Tada schnelles Aufladen",
  scanLogin:
    "Scannen Sie aus Gründen des Datenschutzes und der Sicherheit des Kontos den Code, um sich anzumelden",
  scanTip:
    'Tipp: Klicken Sie in der oberen rechten Ecke von Tada "Personal Center / Dynamics" auf "Scannen", um den Code für die Anmeldung zu scannen. Gleichzeitig wird die Anmeldung durch Identifizieren des QR-Code-Bildschirmfoto unterstützt',
  scanVersion:
    "Bitte aktualisieren Sie Tada auf die%s-Version und scannen Sie den Code, um sich anzumelden",
  delAccount: "Konto löschen",
  logout: "Ausloggen",

  submit: "Einreichen",
  email_place_holder: "Geben Sie Ihre Mailbox ein",
  contact_email: "Kontakt E-mail",
  provide_email:
    "Bitte geben Sie Ihre E-Mail-Adresse an, um eine Zahlungsbenachrichtigung zu erhalten",
  email_address: "E-Mail-Addresse",
  reseller: "Wiederverkäufer",
};



// WEBPACK FOOTER //
// ./src/lang/de.js